import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

export const previousAuditItemsRoot = 'Candidates|History|Audit|Item Review';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryPreviousAuditItemsLoc =
	| 'SPCandidateHistoryPreviousAuditItemsSectionTitle'
	| 'SPCandidateHistoryPreviousAuditItemsCCatNameLabel'
	| 'SPCandidateHistoryPreviousAuditItemsActiveDateLabel'
	| 'SPCandidateHistoryPreviousAuditItemsExpireDateLabel'
	| 'SPCandidateHistoryPreviousAuditItemsCEUsLabel'
	| 'SPCandidateHistoryPreviousAuditItemsDocumentationLabel'
	| 'SPCandidateHistoryPreviousAuditItemsLanguageLabel'
	| 'SPCandidateHistoryPreviousAuditItemsStatusLabel';

export const spCandidateHistoryPreviousAuditItemsLocs: LocDefs<SPCandidateHistoryPreviousAuditItemsLoc> =
	{
		SPCandidateHistoryPreviousAuditItemsSectionTitle: {
			defaultValue: 'Previously Audited Items',
			description: 'Section title for the previous audit items section.',
			displayPath: `${previousAuditItemsRoot}|Previous Section Title`,
			displayType: 'Title',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsCCatNameLabel: {
			defaultValue: 'Requirement',
			description: 'Label for the certification catalog name column',
			displayPath: `${previousAuditItemsRoot}|CCat Name Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsActiveDateLabel: {
			defaultValue: 'Active',
			description: 'Label for the active date column',
			displayPath: `${previousAuditItemsRoot}|Active Date Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsExpireDateLabel: {
			defaultValue: 'Expiration',
			description: 'Label for the expire date column',
			displayPath: `${previousAuditItemsRoot}|Expire Date Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsCEUsLabel: {
			defaultValue: 'CEUs',
			description: 'Label for the CEUs column',
			displayPath: `${previousAuditItemsRoot}|CEUs Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsDocumentationLabel: {
			defaultValue: 'Documentation',
			description: 'Label for the documentation column',
			displayPath: `${previousAuditItemsRoot}|Documentation Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsLanguageLabel: {
			defaultValue: 'Language',
			description: 'Label for the language column',
			displayPath: `${previousAuditItemsRoot}|Language Label`,
			displayType: 'Label',
			...sharedProps,
		},
		SPCandidateHistoryPreviousAuditItemsStatusLabel: {
			defaultValue: 'Item Status',
			description: 'Label for the status column',
			displayPath: `${previousAuditItemsRoot}|Status Label`,
			displayType: 'Label',
			...sharedProps,
		},
	};

export const spCandidateHistoryPreviousAuditItemsLocKeys =
	MapLocKeys<SPCandidateHistoryPreviousAuditItemsLoc>(spCandidateHistoryPreviousAuditItemsLocs);
export type SPCandidateHistoryPreviousAuditItemsLocKeys =
	typeof spCandidateHistoryPreviousAuditItemsLocKeys;
